/**
 * Development-only toast helper
 * Shows error toasts for validation failures in development mode only
 * Can be used from MobX classes without React context
 */

import { toastStore } from "../contexts/ToastContext";

/**
 * Shows a development-only error toast
 * @param {string} message - The main error message
 * @param {string} description - Additional error details
 */
export function showDevToast(message, description) {
  // Double safety check - should never be called in production
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  const id = Date.now() + Math.random();
  toastStore.addToast({
    id,
    message,
    title: message,
    description,
    type: "error",
    duration: null, // Error toasts don't auto-dismiss
    position: "top",
  });
}
